import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';

import InputControl from 'components/InputControl';
import SelectControl from 'components/SelectControl';
import Checkbox from 'components/CheckboxControl';

import './LiftControl.scss';

class LiftControl extends Component {

    static propTypes = {
        value: PropTypes.bool,
        className: PropTypes.string,
        label: React.PropTypes.string,
        floor: React.PropTypes.number,
        type: React.PropTypes.number,
        loadersCount: React.PropTypes.number,
        toggleLiftControl: React.PropTypes.func,
        disableControl: React.PropTypes.bool,
    }

    static defaultProps = {
        label: 'Выгрузка',
        floor: undefined,
        disableControl: true,
        loadersCount: 0,
    }
    // TODO refactor
    state = {
        floor: this.props.floor,
        loadersCount: (this.props.loadersCount ? this.props.loadersCount : 0),
        type: (this.props.type ? this.props.type : 0),
        disableControl: this.props.disableControl,
        options: this.props.options,
        optionsLoaders: this.props.loadersOptions,
    }

    componentWillReceiveProps(nextProps) {
        const state = {};

        if (nextProps.type !== this.props.type) {
            state.type = nextProps.type;
        }

        if (nextProps.floor !== this.props.floor) {
            state.floor = nextProps.floor;
        }

        if (typeof nextProps.disableControl === 'boolean') {
            state.disableControl = nextProps.disableControl;
        }

        this.setState(state);
    }

    _onTypeChange = (event, type) => {
        const newType = type[0]

        this.setState({ type: newType });

        if (this.props.onChange) {
            this.props.onChange({
                floor: this.state.floor,
                loadersCount: this.state.loadersCount,
                type: newType,
            });
        }
    }

    _onLoadersChange = (event, loadersCount) => {
        const newLoadersCount = loadersCount[0];

        this.setState({ loadersCount: newLoadersCount });

        if (this.props.onChange) {
            this.props.onChange({
                floor: this.state.floor,
                type: this.state.type,
                loadersCount: newLoadersCount,
            });
        }
    }

    _onFloorChange = (event) => {
        let floor = parseInt(event.target.value);

        if (!isNaN(floor) && floor >= 0) {
            this.setState({ floor });

            if (this.props.onChange) {
                this.props.onChange({
                    floor,
                    type: this.state.type,
                    loadersCount: this.state.loadersCount,
                });
            }
        } else {
            this.setState({
                floor: '',
            });
        }
    }

    _toggleLiftControl = (event) => {
        const disabled = !event.target.checked;

        if (disabled) {
            this.setState({
                disabled: disabled,
                type: 0,
                loadersCount: 0,
            })
        }

        this.setState({
            disableControl: disabled,
        });

        if (this.props.toggleLiftControl) {
            this.props.toggleLiftControl(disabled);
        }
    }

    render() {
        /*const asd = (<h3 style={{ backgroundColor: "#44014C"}}>Лифт?</h3>);*/

        const classLiftControl = classNames('LiftControl', this.props.className)
        const options = [...this.state.options];
        const optionsLoaders = [...this.state.optionsLoaders];

        options.unshift({ value: 0, label: 'Лифт?' })
        optionsLoaders.unshift({ value: 0, label: 'Кол-во грузчиков?' })

        return (
            <div className={classLiftControl}>
                <Checkbox
                  style={{ marginBottom: '10px' }}
                  className="LiftControl-title"
                  type="checkbox"
                  label={this.props.label}
                  name={this.props.label}
                  value={!this.state.disableControl}
                  onChange={this._toggleLiftControl} />
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                <input className="LiftControl-floor"
                    placeholder="Этаж"
                    type="text"
                    value={this.state.floor}
                    maxLength="3"
                    disabled={this.state.disableControl}
                    onChange={this._onFloorChange} />
                  <SelectControl
                      className="LiftControl-type"
                      options={options}
                      value={this.state.type}
                      disabled={this.state.disableControl}
                      onChange={this._onTypeChange}
                  />
                  <SelectControl
                      className="LiftControl-type"
                      options={optionsLoaders}
                      value={this.state.loadersCount}
                      disabled={this.state.disableControl}
                      onChange={this._onLoadersChange}
                  />
                </div>
            </div>
        );
    }

}

export default LiftControl;



// WEBPACK FOOTER //
// ./client/components/LiftControl/LiftControl.js